import React from 'react';

import classNames from 'classnames';

import { formatPrice } from '@shared/helpers';

import cls from './Option.module.css';

export const OptionBalance = ({ accountBalance }) => {
    const formattedBalance = formatPrice(accountBalance?.current_balance, {
        maximumFractionDigits: 2,
        withCurrency: true,
        currencySign: accountBalance?.sign,
    });
    const match = formattedBalance.match(/^(.*?)([.,])(\d{2})([^\d]*)$/);

    const formattedBalanceContent = match ? (
        <>
            {match[1].replace(/[\s\u00A0\u202F]+/g, ',').replace(/\./g, ',')},
            <span className={classNames(cls.kopecks)}>{match[3]}</span>
            {match[4]}
        </>
    ) : (
        formattedBalance
    );

    return <span className={classNames(cls.balance)}>[ {formattedBalanceContent} ]</span>;
};
